var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rectangle-shape"},[_c('h3',[_vm._v(_vm._s(_vm.meta.data.title))]),_c('p',[_vm._v("Meta: "+_vm._s(JSON.stringify(_vm.meta)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }